import { ValidationBuilder } from "@ajayvikas/react-fluent-validation";
import t from "../i18n";

declare type Login = {
    email: string,
    password: string,
    rememberMe: boolean,
}
declare type Guest = {
    guestEmail: string,
}
declare type Register = {
    email: string,
    password: string,
    confirmPassword: string,
}
declare type ChangePassword = {
    currentPassword: string,
    newPassword: string,
    confirmNewPassword: string,
}
export const loginValidator = new ValidationBuilder<Login>()
    .ensure("email")
    .required().withMessage(t.validations("user_name_required"))
    .ensure("password")
    .required().withMessage(t.validations("password_required"))
    .build();
export const guestCheckoutValidator = new ValidationBuilder<Guest>()
    .ensure("guestEmail")
    .required().withMessage(t.validations("guest_email_required"))
    .email().withMessage(t.validations("valid_email"))
    .build();
export const registerValidator = new ValidationBuilder<Register>()
    .ensure("email")
    .required().withMessage(t.validations("user_name_required"))
    .email().withMessage(t.validations("valid_email"))
    .ensure("password")
    .required().withMessage(t.validations("password_required"))
    .isNumericPresent().withMessage(t.validations("pass_rule_4"))
    .isLowerCasePresent().withMessage(t.validations("pass_rule_2"))
    .isUpperCasePresent().withMessage(t.validations("pass_rule_3"))
    .minLength(6).withMessage(t.validations("password_char_length"))
    .ensure("confirmPassword")
    .satisfies((prop, o) => !!o.password).withMessage(t.validations("password_required"))
    .satisfies((prop, o) => o.password === prop).withMessage(t.validations("confirm_password_short"))
    .build();

export const changePasswordValidator = new ValidationBuilder<ChangePassword>()
    .ensure("currentPassword")
    .required().withMessage(t.validations("current_password_required"))
    .ensure("newPassword")
    .required().withMessage(t.validations("password_required"))
    .isNumericPresent().withMessage(t.validations("pass_rule_4"))
    .isLowerCasePresent().withMessage(t.validations("pass_rule_2"))
    .isUpperCasePresent().withMessage(t.validations("pass_rule_3"))
    .minLength(6).withMessage(t.validations("password_char_length"))
    .ensure("confirmNewPassword")
    .satisfies((prop, o) => !!o.newPassword).withMessage(t.validations("password_required"))
    .satisfies((prop, o) => o.newPassword === prop).withMessage(t.validations("confirm_password_short"))
    .build();
